import { m365AppDefinitionsBehaviorSubject } from '../state';
export var searchAppDefinitions = function (appId) {
    return m365AppDefinitionsBehaviorSubject.value.find(function (_) { return _.id === appId; });
};
//# sourceMappingURL=searchAppDefinitions.js.map